import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-086c3eea")

_pushScopeId("data-v-086c3eea")
const _hoisted_1 = { class: "responsive-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_delivery_performance_summary_card = _resolveComponent("delivery-performance-summary-card")!
  const _component_delivery_performance_detail_card = _resolveComponent("delivery-performance-detail-card")!
  const _component_delivery_performance_per_route_card = _resolveComponent("delivery-performance-per-route-card")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Title, {
      label: _ctx.$t('dashboard.deliveryPerformance')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_delivery_performance_summary_card, { class: "responsive-summary" }),
      _createVNode(_component_delivery_performance_detail_card, { class: "responsive-detail" }),
      _createVNode(_component_delivery_performance_per_route_card, { class: "responsive-per-route" })
    ])
  ]))
})